var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button",
    { attrs: { variant: "primary" }, on: { click: _vm.verifyIdentity } },
    [_vm._v(" Verificar Identidad Mediante Clave Única ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }